import mixpanel from "mixpanel-browser";

import config from "./src/utils/config";

mixpanel.init(config.mixpanel.key);
mixpanel.register({ source: "landing_page" });

exports.onRouteUpdate = ({ location }) => {
  mixpanel.track("page_view", { path: location.pathname });
};

export { mixpanel };



// WEBPACK FOOTER //
// ./gatsby-browser.js